<template>
  <div class="picker-component">
    <div class="setting-time-picker" v-if="add">
      <el-time-picker
        value-format="HH:mm"
        format="HH:mm"
        ref="time"
        default-value="2015-11-11 00:00:00"
        @blur="blur"
        @change="change"
        v-model="value"
      >
      </el-time-picker>
      <div class="add-container" @click="addClick()">
        <div class="add-icon"></div>
      </div>
    </div>
    <div
      class="setting-time-picker"
      @click="selectClick"
      :class="{ select, edit }"
      v-if="!add"
    >
      <el-time-picker
        value-format="HH:mm"
        format="HH:mm"
        :disabled="!edit"
        @change="change"
        v-model="value"
      >
      </el-time-picker>
      <div
        v-if="!add"
        class="icon"
        :class="{ del: edit }"
        @click="delClick"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimePickerComponent",
  model: {
    prop: "model",
    event: "updateValue",
  },
  props: {
    model: {
      // 绑定值
      type: String,
      default: "",
    },
    edit: {
      // 是否处于修改(edit)还是只读(readonly)状态
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: -1,
    },
    select: {
      // 是否选中状态
      type: Boolean,
      default: false,
    },
    add: {
      // 添加模式
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addClick() {
      // 清除选项
      this.value = "";
      // 焦点打开时间选择
      this.$refs.time.focus();
    },
    /**
     * 删除点击事件
     */
    delClick() {
      if (this.edit) {
        this.$emit("remove", { index: this.index });
      }
    },
    /**
     * 选中点击事件
     */
    selectClick() {
      if (!this.edit) {
        this.$emit("select", { index: this.index });
      }
    },
    blur() {
      if (this.value) {
        this.$emit("add", { time: this.value, index: this.index });
      }
    },
    change() {
      this.$emit("updateValue", this.value);
    },
  },
  data() {
    return {
      value: this.model,
    };
  },
  watch: {
    model(val) {
      this.value = val;
    },
  },
};
</script>
<style lang="less">
@import "../../../assets/style/theme.less";

@time-picker-height: 30px;
.picker-component {
  margin-top: 10px;
  margin-right: 10px;
  display: inline-block;
  .setting-time-picker {
    width: 100px;
    height: @time-picker-height;
    background-color: #f0f0f0;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding: 0 7px 0 10px;
    cursor: pointer;
    &.edit {
      cursor: default;
    }
    .el-input.is-disabled .el-input__inner {
      cursor: pointer !important;
    }
    .add-container {
      height: @time-picker-height;
      position: absolute;
      left: 0;
      right: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: #f0f0f0;
      .add-icon {
        width: 22px;
        height: 22px;
        background-size: contain;
        background-image: url("../../../../public/images/setting/Add_Detail_Gray@3x.png");
      }
    }
    &.select {
      background: @theme-color;
      .icon {
        background-image: url("../../../../public/images/setting/select_1@3x.png");
        &.del {
          background-image: url("../../../../public/images/setting/close_w.png");
        }
      }
      .el-input input {
        color: white;
      }
    }
    .el-input {
      width: 60px !important;
    }
    .el-input input {
      background: transparent !important;
      height: @time-picker-height !important;
      line-height: @time-picker-height !important;
      padding-left: 0 !important;
      font-size: 16px !important;
    }
    .icon {
      width: 12px;
      height: 12px;
      background-size: contain;
      cursor: pointer;
      background-image: url("../../../../public/images/setting/select_3@3x.png");
      &.del {
        background-image: url("../../../../public/images/setting/close_r.png");
      }
    }
  }
}
</style>
